(function () {
	'use strict';

	angular
		.module('app.common')
		.directive('investment', Investment);

	function Investment() {
		var directive = {
			templateUrl: '/app/common/investment.html',
			scope: {
				valueIncrease: '=',
				rentIncrease: '=',
				forecastLoading: '=',
				rent: '=',
				sales: '=',
				land: '=',
				field: '=',
				propertyage: '=',
				tasinmazid: '='
			},
			restrict: 'EA',
			controller: investmentController,
			controllerAs: 'vm',
			bindToController: true
		};
		return directive;
	}
	investmentController.$inject = ['$timeout', '$rootScope',"$state"];
	function investmentController($timeout, $rootScope,$state) {
		var vm = this;
		vm.loanTerms = [
			{ value: 12, label: '1 yıl (12 ay)' },
			{ value: 24, label: '2 yıl (24 ay)' },
			{ value: 36, label: '3 yıl (36 ay)' },
			{ value: 48, label: '4 yıl (48 ay)' },
			{ value: 60, label: '5 yıl (60 ay)' },
			{ value: 72, label: '6 yıl (72 ay)' },
			{ value: 84, label: '7 yıl (84 ay)' },
			{ value: 96, label: '8 yıl (96 ay)' },
			{ value: 108, label: '9 yıl (108 ay)' },
			{ value: 120, label: '10 yıl (120 ay)' }
		];

/* 		vm.redirectToUrl = function () {
			var queryParams = {
				amount: vm.calculation.principal,
				installment: vm.calculation.payments,
				id: vm.tasinmazid,
				langcode: $rootScope.lang
			};
			$state.go('mortgage-akbank', queryParams);

		}; */

		var assignValuation = function () {
			vm.calculation.valueIncrease = +vm.valueIncrease;
			vm.calculation.rentIncrease = +vm.rentIncrease;
			vm.forecastLoading = false;

			vm.calculation.value = vm.sales;
			vm.calculation.declaredValue = vm.sales;
			vm.calculation.rent = vm.rent;
			vm.calculation.principal = !vm.land && !vm.field ? Math.floor(vm.calculation.value * vm.calculation.loanAllowance / 100, 0) : 0;
			vm.calculation.maintenance = vm.land || vm.field ? 0 : vm.calculation.maintenance;

			vm.calculation.deprecation = vm.land || vm.field ? 0 : calculateDeprecation(vm.calculation.deprecation, vm.propertyage);
			vm.calculation.valueIncrease = (vm.land || vm.field) && !vm.calculation.valueIncrease ? vm.calculation.inflation : vm.calculation.valueIncrease;
			vm.iterateReturn(1, 1);
		}
		$timeout(function () {
			assignValuation();
		});

		$rootScope.$on('forecastLoaded', function (e, data) {
			vm.valueIncrease = +data.valueIncrease;
			vm.rentIncrease = +data.rentIncrease;
			assignValuation();
		});

		vm.calculation = {
			value: 0,
			declaredValue: 0,
			rent: 0,

			principal: 0,
			rentIncrease: 35,
			valueIncrease: 50,
			inflation: 32.5,

			interest: 3.13,
			loanAllowance: 40,
			downPayment: 0,
			payments: 60,
			duration: 120,

			tax: 4,
			comission: 4,
			insurance: 0,

			maintenance: 2000,
			deprecation: 4,

			result: {
				isRent: false,

				monthlyPayment: 0,
				totalPayment: 0,
				totalInterest: 0,

				tax: 0,
				comission: 0,

				totalInvestment: 0,
				totalIncome: 0,
				totalNetIncome: 0,
				totalExpense: 0,
				totalProfit: 0,
			}
		}

		vm.showCalculated = true;
		var maxAmortization = 1200;
		vm.iterateReturn = function (x, force, deprecation, profit) {
			var breakeven = vm.calculation.result.totalProfit;
			if (profit == 1) {
				vm.calculation.result.isRent = false;
				breakeven = vm.calculation.result.totalProfit;
			}
			else if (profit == 2) {
				vm.calculation.result.isRent = true;
				breakeven = vm.calculation.result.totalNetIncome;
			}
			if (vm.calculation.rent <= 0) {
				vm.calculation.result.isRent = false;
				breakeven = vm.calculation.result.totalProfit;
			}
			if (x <= maxAmortization && breakeven < 0 || force) {
				vm.showCalculated = true;
				vm.calculation.duration = x;
				vm.calculateReturn(deprecation);
				x++;
				vm.iterateReturn(x, 0, deprecation, profit);
			} else if (x > maxAmortization) {
				vm.showCalculated = false;
			}
		}
		vm.numericValue = { currencySymbol: window.currencySymbol, currencySymbolPlacement: 's', decimalPlaces: 0, outputFormat: 'number', upDownStep: 250, modifyValueOnWheel: false, minimumValue: 0 };
		vm.numericRate = { suffixText: '%', decimalPlaces: 2, outputFormat: 'number', upDownStep: 0.01, modifyValueOnWheel: false, minimumValue: 0 };
		vm.numericMonth = { decimalPlaces: 0, outputFormat: 'number', upDownStep: 1, modifyValueOnWheel: false, maximumValue: maxAmortization, minimumValue: 0 };
		vm.numericMonthMin = { decimalPlaces: 0, outputFormat: 'number', upDownStep: 1, modifyValueOnWheel: false, maximumValue: maxAmortization, minimumValue: 1 };

		var calculateDeprecation = function (duration, actualAge) {
			var age = +(duration / 12 + actualAge);

			if (age <= 3) {
				return 4;
			} else if (age >= 4 && age <= 5) {
				return 6;
			} else if (age >= 6 && age <= 10) {
				return 10;
			} else if (age >= 11 && age <= 15) {
				return 15;
			} else if (age >= 16 && age <= 20) {
				return 20;
			} else if (age >= 21 && age <= 30) {
				return 25;
			} else if (age >= 31 && age <= 40) {
				return 32;
			} else if (age >= 41 && age <= 50) {
				return 40;
			} else if (age >= 51 && age <= 75) {
				return 50;
			} else if (age > 75) {
				return 60;
			} else {
				return 10;
			}
		}

		vm.calculateReturn = function (deprecation) {
			vm.calculation.loanAllowance = Math.floor(vm.calculation.principal / vm.calculation.value * 100, 0);
			vm.calculation.insurance = Math.floor(vm.calculation.principal * 3.5 / 100, 0);

			vm.calculation.downPayment = vm.calculation.value - vm.calculation.principal;

			if (!deprecation)
				vm.calculation.deprecation = vm.land || vm.field ? 0 : calculateDeprecation(vm.calculation.duration, vm.propertyage);


			//vm.calculation.interest = vm.calculation.payments <= interestValuesAkbank.rates[0].barrier ? interestValuesAkbank.rates[0].higherRate : interestValuesAkbank.rates[0].lowerRate
			vm.calculation.interest = window.getMortgageRate(window.interestValuesAkbank, 'insured', vm.calculation.payments);
			var principal = vm.calculation.principal;
			var interest = vm.calculation.interest > 0 ? vm.calculation.interest / 100 : 0;
			var payments = vm.calculation.payments;

			var x = Math.pow(1 + interest, payments);
			var monthly = principal * x * interest > 0 ? (principal * x * interest) / (x - 1) : principal / payments;

			vm.calculation.result.monthlyPayment = Math.round(monthly);
			vm.calculation.result.totalPayment = Math.round(monthly * payments);
			vm.calculation.result.totalInterest = Math.round((monthly * payments) - principal);

			vm.calculation.result.tax = Math.floor(vm.calculation.declaredValue * vm.calculation.tax / 100, 0);
			vm.calculation.result.comission = Math.floor(vm.calculation.value * vm.calculation.comission / 100, 0);

			vm.calculation.result.totalExpense = vm.calculation.insurance + vm.calculation.result.tax + vm.calculation.result.comission;
			vm.calculation.result.totalInvestment = vm.calculation.downPayment + vm.calculation.result.totalPayment + vm.calculation.result.totalExpense;

			vm.calculation.maintenance = vm.calculation.rent > 0 ? 2000 : 500;

			vm.calculation.result.totalMaintenance = calculateRentIncome(vm.calculation.maintenance * 12, vm.calculation.inflation, vm.calculation.duration);


			vm.calculation.result.totalValueIncome = addInflation(vm.calculation.value, vm.calculation.valueIncrease, vm.calculation.duration);
			vm.calculation.result.totalDeprecation = Math.abs(vm.calculation.result.totalValueIncome * vm.calculation.deprecation / 100);

			vm.calculation.result.totalRentIncome = calculateRentIncome(vm.calculation.rent * 12, vm.calculation.rentIncrease, vm.calculation.duration);
			vm.calculation.result.totalTax = vm.calculation.result.totalRentIncome > 0 ? vm.calculation.result.totalRentIncome / 12 : 0;

			vm.calculation.result.totalCost = vm.calculation.result.totalPayment + vm.calculation.result.totalMaintenance + vm.calculation.result.totalTax + addInflation(+(vm.calculation.downPayment + vm.calculation.result.totalExpense), vm.calculation.inflation, vm.calculation.duration);

			vm.calculation.result.totalNetIncome = (vm.calculation.rent > 0 ? vm.calculation.result.totalRentIncome - vm.calculation.result.totalCost : 0);
			vm.calculation.result.totalNetIncomePV = calculatePresentValue(vm.calculation.result.totalNetIncome, vm.calculation.inflation, vm.calculation.duration);

			vm.calculation.result.yield = +(vm.calculation.result.totalNetIncome / (vm.calculation.result.totalValueIncome - vm.calculation.result.totalDeprecation) * 100).toFixed(2);
			vm.calculation.result.totalLostOnInflation = addInflation(vm.calculation.value, vm.calculation.inflation, vm.calculation.duration);

			vm.calculation.result.totalProfit = vm.calculation.result.totalValueIncome - vm.calculation.result.totalLostOnInflation - vm.calculation.result.totalDeprecation + vm.calculation.result.totalNetIncome;
			vm.calculation.result.totalProfitPV = calculatePresentValue(vm.calculation.result.totalProfit, vm.calculation.inflation, vm.calculation.duration);
		}

		function calculatePresentValue(futureValue, inflationRate, months) {
			var years = months / 12;
			inflationRate = inflationRate > 0 ? inflationRate / 100 : 0;
			var discountRate = Math.pow(1 + inflationRate, years);
			var presentValue = futureValue / discountRate;
			return +(presentValue.toFixed(2));
		}

		function calculateRentIncome(initialRent, inflationRate, periods) {
			var i = inflationRate > 0 ? inflationRate / 100 : 0;
			var n = periods / 12;

			var rentIncome = initialRent * ((Math.pow(1 + i, n) - 1) / i);
			return +(rentIncome.toFixed(2));
		}

		function addInflation(originalAmount, inflationRate, months) {
			var i = inflationRate > 0 ? inflationRate / 100 : 0;
			var n = months / 12;
			return +((originalAmount * Math.pow(1 + i, n)).toFixed(2));
		}


	}
})();